import dayjs from 'dayjs';
import 'dayjs/locale/it';

dayjs.locale('it');

/**
 * Escapes CSV values that contain commas, quotes, or newlines
 * @param {any} value - The value to escape
 * @returns {string} - Escaped CSV value
 */
const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

/**
 * Prepares enrollments data for export
 * @param {Array} enrollments - Array of enrollment objects
 * @returns {Array} - Prepared enrollment data
 */
const prepareEnrollmentsData = (enrollments) => {
  if (!enrollments) return [];
  
  return enrollments
    .filter((enrollment) => enrollment.amount > 0)
    .map((enrollment, index) => {
      const user = enrollment.user || enrollment.userId || {};
      return {
        id: enrollment._id || index,
        courseName: enrollment.course?.name || '-',
        name: `${user.name || '-'} ${user.surname || '-'}`,
        paymentMethod: enrollment.paymentMethod || '-',
        paymentStatus: enrollment.paymentStatusInfo?.isEnrollmentPaid ? 'Pagato' : 'Da Pagare',
        amount: enrollment.amount || '-',
        enrollmentDate: enrollment.startDate ? dayjs(enrollment.startDate).locale('it').format('MMM YY') : '-',
        nextPaymentDate: enrollment.paymentStatusInfo?.nextPaymentDate ? dayjs(enrollment.paymentStatusInfo.nextPaymentDate).locale('it').format('DD-MMM-YY') : '-',
        paymentsMade: enrollment.paymentStatusInfo?.paymentsMade || 0,
        totalPayments: enrollment.totalPayments || 0,
        paymentsLate: enrollment.paymentStatusInfo?.paymentsLate || 0
      };
    });
};

/**
 * Exports enrollments payment data to CSV file
 * @param {Array} enrollments - Array of enrollment objects
 */
export const exportEnrollmentsToCSV = (enrollments) => {
  if (!enrollments || enrollments.length === 0) {
    return;
  }

  // CSV Headers
  const headers = [
    'Corso',
    'Nome + Cognome',
    'Metodo Pagamento',
    'Stato Pagamento',
    'Importo',
    'Data Iscrizione',
    'Prossima Scadenza Pagamento',
    'Rate',
    'In Ritardo'
  ];

  // Prepare and convert data to CSV format
  const preparedData = prepareEnrollmentsData(enrollments);
  const csvRows = preparedData.map(row => [
    row.courseName,
    row.name,
    row.paymentMethod,
    row.paymentStatus,
    `€${row.amount}`,
    row.enrollmentDate,
    row.nextPaymentDate,
    `${row.paymentsMade}/${row.totalPayments}`,
    row.paymentsLate
  ]);

  // Create CSV content
  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...csvRows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');

  // Create blob and download file
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `stato_pagamenti_iscrizioni_${dayjs().format('DD-MMM-YY')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

